"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleUploadFile = void 0;

var _uploading = require("./uploading");

var _uploadFailed = require("./uploadFailed");

//处理上传文件
var handleUploadFile = function handleUploadFile(_ref) {
  var noFile = _ref.noFile,
      dialogObj = _ref.dialogObj,
      dialogType = _ref.dialogType,
      uploadBtnId = _ref.uploadBtnId,
      isVideoCover = _ref.isVideoCover,
      handleUpload = _ref.handleUpload,
      uploadContainer_ckeDomEle = _ref.uploadContainer_ckeDomEle;
  var dialogEleId, fileInputTemplate;

  if (dialogType == "image") {
    dialogEleId = "txtUrl";
    fileInputTemplate = "<input id=\"input_".concat(uploadBtnId, "\" type=\"file\" style=\"font-size: 999px; opacity: 0; position: absolute; top: 0px; left: 0px; width: 42.61px; height: 27px;\" accept=\"image/jpeg,.jpg,.jpeg,image/png,.png,image/gif,.gif\">");
  } else if (dialogType == "html5video") {
    if (isVideoCover) {
      dialogEleId = "poster";
      fileInputTemplate = "<input id=\"input_".concat(uploadBtnId, "\" type=\"file\" style=\"font-size: 999px; opacity: 0; position: absolute; top: 0px; left: 0px; width: 42.61px; height: 27px;\" accept=\"image/jpeg,.jpg,.jpeg,image/png,.png\">");
    } else {
      dialogEleId = "url";
      fileInputTemplate = "<input id=\"input_".concat(uploadBtnId, "\" type=\"file\" style=\"font-size: 999px; opacity: 0; position: absolute; top: 0px; left: 0px; width: 42.61px; height: 27px;\" accept=\"video/mp4,.mp4\">");
    }
  }

  if (!noFile) {
    uploadContainer_ckeDomEle.setStyles({
      position: "relative"
    });
    uploadContainer_ckeDomEle.appendHtml(fileInputTemplate);
    uploadContainer_ckeDomEle.findOne("#input_".concat(uploadBtnId)).on("click", function (e) {
      e.sender.setValue("");
    });
    uploadContainer_ckeDomEle.findOne("#input_".concat(uploadBtnId)).on("change", function (e) {
      handleUpload({
        type: isVideoCover ? "image" : dialogType,
        file: e.sender.$.files[0],
        uploadingCb: _uploading.uploading,
        uploadFailedCb: _uploadFailed.uploadFailed,
        uploadSuccessCb: function uploadSuccessCb(fullUrl) {
          //切换tab并将链接填入相应的位置
          !isVideoCover && dialogObj.selectPage("info");
          dialogObj.getContentElement("info", dialogEleId).setValue(fullUrl);
        }
      });
    });
  } else {
    uploadContainer_ckeDomEle.findOne("#".concat(uploadBtnId)).on("click", function (e) {
      handleUpload({
        type: isVideoCover ? "image" : dialogType,
        uploadingCb: _uploading.uploading,
        uploadFailedCb: _uploadFailed.uploadFailed,
        uploadSuccessCb: function uploadSuccessCb(fullUrl) {
          //切换tab并将链接填入相应的位置
          !isVideoCover && dialogObj.selectPage("info");
          dialogObj.getContentElement("info", dialogEleId).setValue(fullUrl);
        }
      });
    });
  }
};

exports.handleUploadFile = handleUploadFile;